// extracted by mini-css-extract-plugin
export var linkContainer = "plan-site-module--link-container--4afe9";
export var linksTitle = "plan-site-module--links-title--ab112";